<template>
    <div :class="isMobile == 0 ? '' : 'ProjectOne_mobile'" class="ProjectOne">
        <div :class="isMobile == 0 ? '' : 'ProjectOne_box_mobile'" class="ProjectOne_box">
            <!-- 直接使用 computed 属性，无需 data 中的变量 -->
            <div class="ProjectOne_top" v-if="lang.fyType == 2">{{ BigType }}/{{
                projectData[0].parent_name_translation[0].language == 'en' ?
                    projectData[0].parent_name_translation[0].content : projectData[0].parent_name_translation[1].content
                }}</div>
            <div class="ProjectOne_top" v-else>
                <div v-if="BigType == 'INDOOR'">室内</div>
                <div v-else-if="BigType == 'OUTDOOR'">室外</div>
                /{{
                    projectData[0].parent_name_translation[0].language == 'zh' ?
                        projectData[0].parent_name_translation[0].content : projectData[0].parent_name_translation[1].content
                }}
            </div>

            <div :class="isMobile == 0 ? '' : 'ProjectOne_title_mobile'" class="ProjectOne_title"
                v-if="lang.fyType == 2">{{
                    projectData[0].parent_name_translation[0].language == 'en' ?
                        projectData[0].parent_name_translation[0].content : projectData[0].parent_name_translation[1].content
                }}</div>
            <div :class="isMobile == 0 ? '' : 'ProjectOne_title_mobile'" class="ProjectOne_title" v-else>{{
                projectData[0].parent_name_translation[0].language == 'zh' ?
                    projectData[0].parent_name_translation[0].content : projectData[0].parent_name_translation[1].content
                }}</div>
            <!-- <div class="ProjectOne_title">{{ SmallType }}</div> -->
            <div
            :class="isMobile == 0 ? '' : 'ProjectOne_list_mobile'"
            class="ProjectOne_list">
                <!-- 用 projectData 渲染列表（示例） -->
                <div :class="isMobile == 0 ? '' : 'ProjectOne_itemg_mobile'" @click="getProList(item)"
                    class="ProjectOne_item" v-for="(item, index) in projectData" :key="index"
                    :style="{ animationDelay: `${0.2 + index * 0.1}s` }">
                    <img :class="isMobile == 0 ? '' : 'ProjectOne_img_mobile'" class="ProjectOne_img"
                        :src="'https://app.choisiyachts.com' + item.image" />
                    <div :class="isMobile == 0 ? '' : 'ProjectOne_type_mobile'" class="ProjectOne_type">{{
                        item.translations.name.content }}</div>
                </div>
            </div>
        </div>
        <bottom-text></bottom-text>
    </div>
</template>

<script>
import { proCategories, proList } from '../../request/api.js'
import router from '@/router';
import bottomText from './bottomText.vue';

export default {
    components: {
        bottomText
    },
    name: 'BrandStory',
    data() {
        return {
            lang: {},
            projectData: [], // 用于渲染视图的实际数据
            proType: '',
            src: [],
            isMobile: 0
        }
    },
    // 监听路由变化（包括 query 参数变化）
    watch: {
        $route: {
            handler(newRoute, oldRoute) {
                // 比较新旧路由的 t 参数，不同则刷新数据
                if (newRoute.query.t !== oldRoute.query.t) {
                    this.refreshPageData(); // 自定义刷新方法
                }
            },
            immediate: true // 初始加载时也执行一次（确保首次有数据）
        },
        lang: {
            handler(newLang, oldLang) {
                console.log('Lang 变化了：', newLang);
            },
            deep: true, // 关键：监听对象内部属性（如 Lang/fyType）的变化
            immediate: true // 可选：组件初始化时就执行一次监听逻辑（避免首次加载无数据）
        }
    },
    mounted() {
        this.isMobile = localStorage.getItem('isMobile')
        this.lang = JSON.parse(localStorage.getItem('Lang'))
        if (this.lang.fyType == 2) {
            this.getProCategories(this.$route.params.parent_id, 'en');
        } else {
            this.getProCategories(this.$route.params.parent_id, 'zh');
        }
        window.addEventListener('langChange', () => {
            this.syncLangFromStorage(); // 同步最新语言到响应式变量（触发 watch）
        });
    },
    computed: {
        // 正确获取命名路由参数（与路由配置中的 :type 和 :smalltype 对应）
        BigType() {
            return this.$route.params.type || '未知大类';
        },
        SmallType() {
            return this.$route.params.smalltype || '未知小类';
        },
        ParentId() {
            return this.$route.params.parent_id || '未知id'
        }
    },
    methods: {
        refreshPageData() {
            // 1. 清空旧数据（避免视图残留）
            this.projectData = [];
            this.src = [];

            // 2. 根据当前语言重新加载数据
            if (this.lang?.fyType === 2) {
                this.getProCategories(this.$route.params.parent_id, 'en');
            } else {
                this.getProCategories(this.$route.params.parent_id, 'zh');
            }
        },
        async getImge(category_id, i, length) {
            let data = {
                category_id,
                type: 2,
                language: 'zh',
                // is_recommend: 1
            }
            let res = await proList(data)
            if (res.data.data.length == 0) {
                this.src.push('')
                return
            }
            this.$set(this.src, i, res.data.data[0].images[0].image_url.split(',')[0]);
            // this.src[i]=res.data.data[0].images[0].image_url.split(',')[0]
            console.log(this.src)

            // this.src.push(res.data.data[0].images[0].image_url.split(',')[0])
        },
        syncLangFromStorage() {
            this.lang = JSON.parse(localStorage.getItem('Lang'))
            if (this.lang.fyType == 2) {
                this.getProCategories(this.$route.params.parent_id, 'en');
            } else {
                this.getProCategories(this.$route.params.parent_id, 'zh');
            }
        },
        loadProjectData(language) {
            console.log('路由变化，刷新数据');
            // 正确获取命名参数
            const type = this.$route.params.type;
            const smalltype = this.$route.params.smalltype;
            const id = this.$route.params.parent_id;
            this.proType = '';
            this.getProCategories(id, language);
        },
        getProCategories(id, language) {
            let data = {
                id,
                language
            }
            proCategories(data).then((res) => {
                this.projectData = res.data;
                for (let i = 0; i < this.projectData.length; i++) {
                    this.src = new Array(this.projectData.length).fill('');
                    this.getImge(this.projectData[i].id, i, this.projectData.length)
                }
            })
        },
        // 跳转示例（添加时间戳 query 参数）
        getProList(item, language) {
            localStorage.setItem('twoItem', JSON.stringify(item));
            console.log('跳转到产品列表页', item);
            item.parent_name_translation[0]
            localStorage.setItem('proListId', item.id);
            localStorage.setItem('lanType', JSON.stringify(this.projectData[0].parent_name_translation));
            router.push({
                path: `/project-two/${this.BigType}/${this.SmallType}/${item.id}`
            });
        },
    }
}
</script>

<style>
/* 1. 新增：悬浮显现动画关键帧 */
@keyframes floatFadeIn {
    0% {
        opacity: 0;
        /* 初始完全透明 */
        transform: translateY(20px);
        /* 初始向下偏移20px，营造悬浮感 */
    }

    100% {
        opacity: 1;
        /* 结束完全显示 */
        transform: translateY(0);
        /* 结束回到原位置 */
    }
}

.ProjectOne {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 100%;
}

.ProjectOne_mobile {
    height: 88%;
}

/* 原有样式保持不变，以下是你原本的代码 */
.ProjectOne_box {
    padding-left: 100px;
    width: 1460px;
    margin: 60px auto;
}

.ProjectOne_box_mobile {
    width: 100%;
    padding-left: 0px;
    margin: 20px auto;
}

.ProjectOne_top {
display: flex;
align-items: center;
    margin-left: 10px;
    font-family: Arial, sans-serif;
    font-weight: 400;
    font-size: 16px;
    color: #021131;
    margin-bottom: 10px;
    /* 2. 新增：给面包屑绑定动画 */
    animation: floatFadeIn 0.5s ease forwards;
}

.ProjectOne_title {
    font-family: Arial, sans-serif;
    font-weight: 600;
    font-size: 36px;
    color: #021131;
    margin-bottom: 40px;
    /* 2. 新增：给标题绑定动画，延迟0.1s，比面包屑晚出现 */
    animation: floatFadeIn 0.5s ease 0.1s forwards;
    opacity: 0;
    /* 初始隐藏，避免动画前闪现 */
}

.ProjectOne_title_mobile {
    margin-left: 10px;
    font-size: 30px;
    margin-bottom: 10px;
}

.ProjectOne_list {
    display: flex;
    align-items: flex-start;
    flex-wrap: wrap;
    /* 一行三个：两项间距共 40px */
    gap: 40px 20px;
}
.ProjectOne_list_mobile{
    justify-content: space-around;
    gap: 20px 0;
}
.ProjectOne_item {
    width: calc((100% - 40px) / 3);
    margin-right: 0;
    margin-bottom: 0;
    box-sizing: border-box;
    transition: transform 0.3s ease, box-shadow 0.3s ease;
    /* 2. 新增：给列表项绑定动画，初始隐藏 */
    animation: floatFadeIn 0.5s ease forwards;
    opacity: 0;
}

.ProjectOne_itemg_mobile {
    width: auto;
    margin-right: 0px;
}

/* 原有hover效果不变 */
.ProjectOne_item:hover {
    transform: scale(1.05);
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.ProjectOne_img {
    width: 100%;
    height: 283px;
    object-fit: cover;
    display: block;
    margin-bottom: 20px;
}

.ProjectOne_img_mobile {
    width: 180px;
    height: 120px;
}

.ProjectOne_type {
    margin: 0px 10px 10px 10px;
    font-family: Arial, sans-serif;
    font-weight: 500;
    font-size: 20px;
    color: #021131;
    text-align: left;
}

.ProjectOne_type_mobile {
    font-size: 14px;
    width: 160px;
    display: -webkit-box;
    overflow: hidden;
    text-overflow: ellipsis;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
}
</style>
